import { Injectable } from '@angular/core';
import { 
  ActivatedRouteSnapshot, 
  CanActivate, 
  ActivatedRoute,
  Router, 
  RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private _fuseNavigationService: FuseNavigationService, 
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<boolean> {
    console.log("test");
      var succes = of(false);
      var test = this.authService.isAuthenticated().subscribe((isLoggedIn: boolean) => {         // {3}
      if (!isLoggedIn){
        console.log("niet ingelogd authguard");
        console.log(isLoggedIn);
        this.router.navigate(['/login']);  // {4}
        succes = of(false);
      } else {
        this.setNavigationRoles();
        console.log(this.route.snapshot.firstChild);
        let roles = next.data["roles"] as Array<string>;
        if (this.route.snapshot.firstChild != null) {
          if (this.route.snapshot.firstChild.data["roles"]) {
            roles = this.route.snapshot.firstChild.data["roles"] as Array<string>;
            console.log(this.route.snapshot.firstChild.data["roles"]);
          }
          else {
            roles = next.data["roles"] as Array<string>;
          }
        } else {
          roles = next.data["roles"] as Array<string>;
        
        }
        console.log(roles);
        if (roles) {
          var match = this.authService.getRoleMatch(roles);
          if (match) {
            console.log(match);
            succes = of(true);
          } else {
            console.log("forbidden");
            this.router.navigate(['/forbidden']);
            succes = of(false);
          }
        } else {
          succes = of(true);
        }
      }
    });        

    console.log(test);
    return succes;

  }

  setNavigationRoles(){

    this._fuseNavigationService.updateNavigationItem('medewerkers', {
        hidden: true
    });
    this._fuseNavigationService.updateNavigationItem('afdelingen', {
        hidden: true
    });
    this._fuseNavigationService.updateNavigationItem('planningoverzicht', {
        hidden: true
    });
    this._fuseNavigationService.updateNavigationItem('planningsimpel', {
        hidden: true
    });
    this._fuseNavigationService.updateNavigationItem('planningsimpelKlant', {
        hidden: true
    });
    this._fuseNavigationService.updateNavigationItem('buitendienst', {
        hidden: true
    });
    this._fuseNavigationService.updateNavigationItem('home', {
        hidden: true
    });
    this._fuseNavigationService.updateNavigationItem('homeklant', {
        hidden: true
    });

    var userRoles: string[] = JSON.parse(localStorage.getItem('userRoles'));
    userRoles.forEach(element => {
        if (element == "mws") {
            this._fuseNavigationService.updateNavigationItem('medewerkers', {
                hidden: false
            });
            this._fuseNavigationService.updateNavigationItem('afdelingen', {
                hidden: false
            });
            this._fuseNavigationService.updateNavigationItem('buitendienst', {
                hidden: false
            });
            this._fuseNavigationService.updateNavigationItem('planningoverzicht', {
                hidden: false
            });
            this._fuseNavigationService.updateNavigationItem('planningsimpel', {
                hidden: false
            });
            this._fuseNavigationService.updateNavigationItem('home', {
                hidden: false
            });

        }

        if (element == "planner") {
            this._fuseNavigationService.updateNavigationItem('planningoverzicht', {
                hidden: false
            });
        }

        if (element == "Klant") {
            this._fuseNavigationService.updateNavigationItem('planningsimpelKlant', {
                hidden: false
            });
            this._fuseNavigationService.updateNavigationItem('homeklant', {
                hidden: false
            });
        }
      
    });
    
  }
}